import { store } from "../../App"

// ! search bar and page index
export const searchAndPageIndex = (search, pageIndex) => {
    store.dispatch({ type: "SEARCH_AND_PAGE_INDEX", data: { search, pageIndex } })
}